import { Glyph } from '../common/Glyph';

import { useI18n } from '../../hooks/useI18nFormatters';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './DevicePremiumStatus.module.css';

export function DevicePremiumStatus() {
  const { i18n } = useI18n();

  return (
    <div className={styles.root}>
      <Glyph
        className={styles.statusIcon}
        source={glyph.system.premium}
        color={theme.color.system_premium}
        size={theme.icon.size_small}
      />

      <div className={styles.statusText}>
        {i18n.messageFormatter('premium.label', undefined, 'Premium')}
      </div>
    </div>
  );
}
